import React from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';

import SportTable from 'src/components/SportsBetting/SportTable/SportTable';
import useIsMobile from 'src/hooks/useIsMobile';
import { RootState } from 'src/configs/store';

interface SportSearchProps {
  isTopFilters?: boolean
}

function SportSearch({ isTopFilters = false }: SportSearchProps) {
  const { filterResults, topResults } = useSelector((state: RootState) => state.filters);
  const { searchResults } = useSelector((state: RootState) => state.events);

  const mobile = useIsMobile();

  let currentEvents = searchResults.list;
  if (mobile && filterResults.length > 0) {
    currentEvents = filterResults;
  }

  if (mobile && isTopFilters && topResults.length > 0) {
    currentEvents = topResults;
  }


  return (
    <>
      {
        _.map(currentEvents, (sport) => {
          return (
            <SportTable key={ `upcoming_${ sport.code }` } sport={ sport } />
          );
        })
      }
    </>
  );

}


export default SportSearch;
